module.exports = __webpack_public_path__ + "static/media/Resurs 890.5d28d072.png";